import React from 'react';
import { motion } from 'framer-motion';
interface CTAButtonProps {
  text: string;
  onClick?: () => void;
  className?: string;
  href?: string;
}
export function CTAButton({
  text,
  onClick,
  className = '',
  href
}: CTAButtonProps) {
  const handleClick = () => {
    if (onClick) onClick();
    if (href) {
      // Fire Meta Pixel AddToCart event before redirecting
      const w = window as any;
      if (typeof w.fbq === 'function') {
        w.fbq('track', 'AddToCart', {
          content_name: 'El Protocolo de la Mañana - Pack Completo',
          content_type: 'product',
          value: 13.99,
          currency: 'USD'
        });
      }
      window.location.href = href;
    } else {
      document.getElementById('pricing')?.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} onClick={handleClick} className={`w-full md:w-auto px-8 py-4 bg-gradient-to-r from-gold to-gold-light text-white font-bold text-lg md:text-xl rounded-lg shadow-[0_4px_14px_0_rgba(212,175,55,0.39)] hover:shadow-[0_6px_20px_rgba(212,175,55,0.23)] transition-all duration-300 ${className}`} data-id="element-46">
      {text}
    </motion.button>;
}